import React from 'react';

const RicosViewerContext = React.createContext(null);
const RicosViewerContextProvider = ({
  contextualData: {
    anchorTarget,
    relValue,
    config,
    helpers,
    disabled,
    seoMode,
    iframeSandboxDomain,
    disableRightClick,
    customAnchorScroll,
    textAlignment,
    onNodeClick
  },
  children
}) => {
  return /* @__PURE__ */ React.createElement(
    RicosViewerContext.Provider,
    {
      value: {
        anchorTarget,
        relValue,
        config,
        helpers,
        disabled,
        seoMode,
        iframeSandboxDomain,
        disableRightClick,
        customAnchorScroll,
        textAlignment,
        onNodeClick
      }
    },
    children
  );
};
const RicosViewerContextConsumer = ({ children }) => /* @__PURE__ */ React.createElement(RicosViewerContext.Consumer, null, (value) => children(value));

export { RicosViewerContext, RicosViewerContextConsumer, RicosViewerContextProvider };
//# sourceMappingURL=ViewerContext.js.map
